

export const walletData = [
    {
        amount_credited:'-',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'-',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 1020",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'-',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 2310",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"-",
        balance:"INR 2310",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"-",
        balance:"INR 2310",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"-",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    },

    {
        amount_credited:'INR 500',
        date_time:"Jan 20 11:16:am",
        amount_debited:"INR 1220",
        balance:"INR 200",
        details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
    }
];


export const walletColumns = [

    {
        name: 'DATE & TIME',
        selector: row => row['date_time'],
        sortable: true,
        center: true,
        // width:"130px",
        
    },
    {
        name: 'BOOKING NO',
        selector: row => row['megaCabsBookingNo'],
        sortable: true,
        center: true,
        // width:"130px",
    },
    {
        name: 'AMOUNT CREDITED',
        selector: row => row['amount_credited'],
        sortable: true,
        center: true,
        // width:"130px",
    },
    {
        name: 'AMOUNT DEBITED',
        selector: row => row['amount_debited'],
        sortable: true,
        center: true,
        // width:"130px",
    },
    // {
    //     name: 'BALANCE',
    //     selector: row => row['balance'],
    //     sortable: true,
    //     center: true,
    //     // maxWidth:"7vw",
    // }
];

export const collectionColumns = [
  {
    name: 'BOOKING NO',
    selector: row => row['MegaCabsBookingNo'],
    sortable: true,
    center: true,
  },
  {
      name: 'TRIP END TIME',
      selector: row => row['TripEndTime'],
      sortable: true,
      center: true,
      
  },
  {
    name: 'COMMISSIONS',
    selector: row => row['Commission'],
    sortable: true,
    center: true,
},
  {
      name: 'COLLECTION AMOUNT',
      selector: row => row['DriverCollectedAmount'],
      sortable: true,
      center: true,
  },
];

export const rechargeColumns = [

  { 
      name: 'DATE & TIME',
      selector: row => row['date_time'],
      sortable: true,
      center: true,
      width:"180px",
      
  },
  {
      name: 'AMOUNT',
      selector: row => row['amount'],
      sortable: true,
      center: true,
      width:"130px",
  },
  {
    name: 'AGENT',
    selector: row => row['agent'],
    sortable: true,
    center: true,
    width:"130px",
    
},
  {
      name: 'MODE',
      selector: row => row['PaymentMode'],
      sortable: true,
      center: true,
      width:"150px",
  },
  {
      name: 'STATUS',
      selector: row => row['PaymentStatus'],
      sortable: true,
      center: true,
      width:"150px",
  },
  {
      name: 'REMARKS',
      selector: row => row['Remark'],
      sortable: true,
      center: true,
      // maxWidth:"200px",
  }

  
];

export const sFEEColumns = [

  { 
      name: 'DATE & TIME',
      selector: row => row['date_time'],
      sortable: true,
      center: true,
      width:"180px",
    
  },
  {
      name: 'AMOUNT',
      selector: row => row['amount'],
      sortable: true,
      center: true,
      width:"130px",
  },
  
  {
      name: 'STATUS',
      selector: row => row['PaymentStatus'],
      sortable: true,
      center: true,
      width:"150px",
  }

  
];

